import { Box, Button, FlexBox, Text } from '@dixa/lib-shared-habla';
import { useCopyToClipboard } from 'react-use';

import { CodeHighlight } from 'components/codeHighlight';

import { DocumentationLink } from '../documentationLink/documentationLink';

interface WebSetupProps {
  messengerToken: string;
}

export function WebSetup({ messengerToken }: WebSetupProps): JSX.Element {
  const embedCode = getEmbedCode(messengerToken);
  const [_, copyTpClipboard] = useCopyToClipboard();

  return (
    <FlexBox flexDirection="column" gap="300">
      <Text.Paragraph variant="3" subdued>
        Script
      </Text.Paragraph>
      <CodeHighlight languages={['js', 'html']}>{embedCode}</CodeHighlight>
      <DocumentationLink />
      <Box>
        <Button icon="copy" onClick={() => copyTpClipboard(embedCode)}>
          Copy script
        </Button>
      </Box>
    </FlexBox>
  );
}

/**
 * This code snippet is used by customers to embed the Dixa Messenger on their
 * website. **It's critical that this code snippet is correct and up-to-date.**
 */
function getEmbedCode(messengerToken: string): string {
  return `<script>
(function (w, d, s) {
  if (w._dixa_) return;
  w._dixa_ = {
    invoke: function (m, a) {
      w._dixa_.pendingCalls = w._dixa_.pendingCalls || [];
      w._dixa_.pendingCalls.push([m, a]);
    },
    addListener: function (event, listener) {
      w._dixa_.pendingAddListenerCalls = w._dixa_.pendingAddListenerCalls || [];
      w._dixa_.pendingAddListenerCalls.push([event, listener]);
    },
  };
  s = d.createElement('script');
  s.type = 'text/javascript';
  s.setAttribute('charset', 'utf-8');
  s.async = true;
  s.src = 'https://messenger.dixa.io/bootstrap.js';
  var before = d.getElementsByTagName('script')[0];
  before.parentNode.insertBefore(s, before);
})(window, document);
_dixa_.invoke('init', { messengerToken: '${messengerToken}' });
</script>`;
}
